export default function TenantChecksCompletedModal({
  tenantName,
  onGoToDashboard,
  _t,
}) {
  const name = tenantName || "Javier";
  return (
    <div
      className="popup-overlay wrapper-modal"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px",
        background: "var(--skor-color-canvas, #f6f6f6)",
        minHeight: "calc(100dvh - var(--onboarding-header-height, 0px))",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 24,
          padding: "36px 32px 28px",
          width: "min(560px, 100%)",
          textAlign: "center",
          boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
          border: "1px solid #ececef",
          margin: "auto",
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "#f1f8ef",
            border: "1px solid #d6e8d2",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 18,
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#23402a"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2
          style={{
            fontSize: 26,
            fontWeight: 800,
            color: "#14201e",
            lineHeight: 1.2,
            margin: "0 0 10px",
            letterSpacing: "-0.02em",
          }}
        >
          {_t ? _t("checkCompleted", "Check completed") : "Check completed"}
        </h2>
        <p
          style={{
            fontSize: 13.5,
            color: "#5a6462",
            lineHeight: 1.45,
            margin: "0 0 20px",
          }}
        >
          {_t
            ? _t(
                "checkCompletedSubtitle",
                "You'll find the results in your dashboard in a few minutes."
              )
            : "You'll find the results in your dashboard in a few minutes."}
        </p>
        <p
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#14201e",
            lineHeight: 1.3,
            margin: "0 0 18px",
          }}
        >
          {_t
            ? _t(
                "youCompletedProfile",
                `You completed ${name}'s profile`,
                undefined,
                { name: name }
              )
            : `You completed ${name}'s profile`}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "#f3f3f5",
            borderRadius: 999,
            padding: "14px 18px",
            textAlign: "left",
            marginBottom: 20,
          }}
        >
          <span style={{ flexShrink: 0, marginTop: 1 }}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6b7674"
              strokeWidth="1.8"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          </span>
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#1e2e2c",
              lineHeight: 1.35,
            }}
          >
            {_t
              ? _t(
                  "processingProfiles",
                  "We're processing the profiles and we'll email you when everything is live"
                )
              : "We're processing the profiles and we'll email you when everything is live"}
          </span>
        </div>
        <button
          type="button"
          onClick={onGoToDashboard}
          style={{
            width: "100%",
            height: 48,
            borderRadius: 14,
            border: 0,
            background: "#1e3430",
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            lineHeight: 1,
            cursor: "pointer",
          }}
        >
          {_t
            ? _t("goToMyDashboard", "Go to my dashboard")
            : "Go to my dashboard"}
        </button>
      </div>
    </div>
  );
}
